import React, { useState, useEffect, useContext } from "react";
import { PillsContainer } from "../ProgramConnections/ProgramConnection/ConnectionProfile/styles";
import Pills from "../../../../../common/Pills";
import ProgramTasks from "../ProgramTasks";
import Survey from "../ProgramSurveys";
import { TaskContainerOuter } from "./styles";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../api/apiCaller";
import { Context } from "../../../../../Store";

const Index = () => {
  const [currentTab, setCurrentTab] = useState("Tasks");
  const [showTasks, setShowTasks] = useState(false);

  //
  let { state, dispatch } = useContext(Context);

  const params = useParams();

  // console.log("Params:", params);

  const programId = +params?.selectedProgram;

  const getOnlyProgramInformation = () => {
    callAPI(dispatch, "getOnlyProgramInformation", {
      id: programId,
    }).then((res) => {
      // console.log("Program Response:", res);

      setShowTasks(res?.data?.programType === "OPEN_NETWORK" ? false : true);
    });
  };

  useEffect(() => {
    if (programId) {
      getOnlyProgramInformation();
    } else {
      console.log("Was Here");
    }
  }, [programId]);
  //

  return (
    <TaskContainerOuter>
      {showTasks && (
        <PillsContainer meetings={true} isConnection={true}>
          <Pills
            meetings={true}
            isWidth={true}
            value={currentTab}
            setValue={setCurrentTab}
            options={[
              showTasks && {
                label: "Tasks",
                value: "Tasks",
              },
              {
                label: "Survey",
                value: "Survey",
              },
            ]}
          />
        </PillsContainer>
      )}
      {currentTab === "Tasks" && showTasks ? <ProgramTasks /> : <Survey />}
    </TaskContainerOuter>
  );
};

export default Index;
